const serverSupportServicesData = [
  {
    title: "Provisioning",
    description:
      "Secure server provisioning with golden images, OS hardening, access controls, and backup policies.",
    bullets: ["OS Hardening", "Users & Keys", "Firewall", "Backups"],
    minHeight: 400,
  },
  {
    title: "Monitoring",
    description:
      "Deep observability with metrics, logs, traces, and actionable alerts to prevent incidents.",
    bullets: ["Prometheus", "Grafana", "ELK", "Alerts"],
    minHeight: 400,
  },
  {
    title: "Patching",
    description:
      "Regular patching cycles with vulnerability scanning, remediation, and compliance reporting.",
    bullets: ["Patching", "CIS Benchmarks", "Scans", "Reports"],
    minHeight: 400,
  },
  {
    title: "Disaster Recovery",
    description:
      "Resilient backups, restore testing, and disaster recovery drills with documented RPO/RTO.",
    bullets: ["RPO/RTO", "Snapshots", "DR Drills", "Runbooks"],
    minHeight: 400,
  },
  {
    title: "Performance",
    description:
      "Performance tuning for CPU, memory, I/O, and caching with proactive capacity planning.",
    bullets: ["Caching", "I/O", "CPU/RAM", "Scaling"],
    minHeight: 400,
  },
  {
    title: "Support",
    description:
      "24/7 on‑call rotation, incident response, root‑cause analysis, and regular service reviews.",
    bullets: ["SLAs", "On‑call", "Incidents", "Reports"],
    minHeight: 400,
  },
  {
    title: "Security Hardening",
    description:
      "Harden systems against threats using CIS benchmarks, vulnerability scanning, and automated remediation.",
    bullets: ["CIS", "Vuln Scans", "Patching", "Audit"],
    minHeight: 400,
  },
  {
    title: "Backup & Restore",
    description:
      "Automated, encrypted backups with policy‑based retention and regular restore tests.",
    bullets: ["Policy", "Automation", "DR Drills", "Reports"],
    minHeight: 400,
  },
  {
    title: "Configuration Mgmt",
    description:
      "Idempotent configuration management using IaC and CM tools to prevent drift and document changes.",
    bullets: ["IaC", "Golden Images", "Drift Detect", "Change Log"],
    minHeight: 400,
  },
];

export default serverSupportServicesData;

export const serverSupportShowcaseData = [
  {
    eyebrow: "NETWORK TROUBLESHOOTING SERVICES",
    title:
      "We have extensive experience in supporting and troubleshooting Networking, Server and Storage solutions.",
    description:
      "Our team of highly trained system engineers understand the core building blocks required to deliver business‑critical services. We can undertake all troubleshooting and support in‑house, and deliver end‑to‑end support. Network problems can also be resolved remotely. We will help you over the phone, via email, through web sessions, or other means necessary to resolve any issues.",
    image: "/assets/img/services/server-support/network.svg",
    theme: "light",
  },
  {
    eyebrow: "EMERGENCY SUPPORT",
    title:
      "Unexpected IT problems can have a shocking effect on your business.",
    description:
      "We provide emergency support services to help get your systems operational again as quickly as possible and with the minimum disruption to your business. Common emergency support includes network and server failure, security breaches, and natural disasters.",
    image: "/assets/img/services/server-support/emergency.svg",
    theme: "accent",
  },
  {
    eyebrow: "BACKUP AND RESTORE",
    title:
      "Data is one of the most critical parts to the running of your business",
    description:
      "The backup of data is useless if it cannot be restored; the ability to quickly recover lost files and data is imperative. We help you optimise your backup environment and improve efficiency, recovery and archiving so it meets requirements, minimises downtime and improves flexibility, manageability and scalability.",
    image: "/assets/img/services/server-support/backup.svg",
    theme: "light",
  },
  {
    eyebrow: "PCI COMPLIANCE",
    title:
      "This is an essential requirement for any business that stores, transmits or processes payment card transactions.",
    description:
      "We help clients to achieve PCI DSS Certification via authorities like Verisign, McAfee, Trustwave and SecurityMetrics. We offer pre‑compliance and gap analysis, vulnerability scans, penetration testing, onsite assessments, and consultancy services.",
    image: "/assets/img/services/server-support/compliance.svg",
    theme: "accent",
  },
];

export const serverSupportSlaMetrics = [
  {
    icon: "🛡️",
    value: "99.95%",
    label: "Uptime Commitment",
    note: "Monthly SLA",
    delta: "+0.02%",
    deltaDirection: "up",
    good: true,
  },
  {
    icon: "⚡",
    value: "< 15m",
    label: "Critical Response (24/7)",
    note: "P1 incidents",
    delta: "Avg 9m",
    deltaDirection: "down",
    good: true,
  },
  {
    icon: "🌍",
    value: "Global",
    label: "Coverage & On‑call",
    note: "Follow‑the‑sun",
  },
  {
    icon: "⏱️",
    value: "< 2h",
    label: "MTTR (Median)",
    note: "Across P1‑P2",
    delta: "▼ 18%",
    deltaDirection: "down",
    good: true,
  },
  { icon: "🧭", value: "< 4h", label: "RTO (Target)", note: "Tier‑1 systems" },
  { icon: "💾", value: "< 30m", label: "RPO (Target)", note: "Critical data" },
  {
    icon: "🔄",
    value: "Quarterly",
    label: "DR Drills",
    note: "Restore verification",
  },
  {
    icon: "🔐",
    value: "CIS",
    label: "Hardening Standard",
    note: "Benchmark aligned",
  },
];
